'use client'

import Typography from '@mui/material/Typography'
import { ForwardedRef, MouseEventHandler, forwardRef } from 'react'
import { tss } from 'tss-react/mui'

// Allowing this import because it's just a type and won't affect tree-shaking the JS bundles

import { IconType } from '../Icon'

const useStyles = tss.create(({ theme }) => ({
    root: {
        color: theme.palette.primary.main,
    },
    icon: {
        position: 'relative',
        top: 4,
        marginRight: theme.spacing(0.5),
    },
}))

type TitleLinkProps = {
    text: string
    Icon?: IconType
    href?: string
    onClick?: MouseEventHandler<HTMLAnchorElement>
}

const TitleLink = forwardRef<HTMLAnchorElement, TitleLinkProps>(function TitleLinkRef(
    { text, Icon, ...props }: TitleLinkProps,
    ref?: ForwardedRef<HTMLAnchorElement>
) {
    const { classes, cx } = useStyles()

    return (
        <Typography
            {...props}
            ref={ref}
            color="primary"
            variant="h4"
            title={text}
            className={cx(classes.root, 'line-clamp-2', 'cursor-pointer')}
        >
            {Icon ? <Icon className={classes.icon} /> : null}
            {text}
        </Typography>
    )
})

export default TitleLink
